module.exports = __webpack_public_path__ + "img/about3.5f8c94dd.png";